import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {

  public capabilities!: string[]
  public reasonsToChoose!:string[]

  ngOnInit(): void {

    this.capabilities = [
      'High-Precision Plastic Injection Molding Tolerances up to ±0.01 mm.',
      'Multi-cavity molds, insert molding, and overmolding.',
      'Expertise in high-performance polymers (ABS, PBT, PC, PA6, etc.).',
      'Large-Volume Production Capabilities.',
      'Scalable to 24/7 high-capacity runs.',
      'Automated part handling and quality assurance systems.',
      'Optimized for cost-per-part efficiency and volume flexibility.',
      'General Assembly & Post-Molding Services.',
      'Mechanical assembly, ultrasonic welding, and component integration.',
      'Kitting, packaging, and labeling per customer specification.',
      'Customizable workflows to align with your downstream operations.'
    ];
  
    this.reasonsToChoose = [
      'Proven track record in <strong> precision part manufacturing. </strong>',
      'Agile response to <strong> engineering changes and scaling needs. </strong>',
      'Focused on <strong> zero-defect quality culture </strong> and <strong> on-time delivery.</strong>',
      'Single-point solution for  <strong>molding + assembly + logistics.</strong>'
    ];
  }
  

}
